import KTTable from 'general/components/OtherKeenComponents/KTTable';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import PropTypes from 'prop-types';
import { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

GeneralSettingView.propTypes = {
    showFullUI: PropTypes.bool,
    prefKey: PropTypes.string,
};

function GeneralSettingView({ showFullUI, prefKey }) {
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const appConfig = useAppConfig();
    const [settingList, setSettingList] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        setSettingList([
            {
                key: 'showShareRatio',
                name: 'Ẩn tỷ lệ góp vốn của NĐT HTKD',
                show: appConfig.showShareRatio,
            }
        ]);
    }, [appConfig.showShareRatio]);

    useEffect(() => {
        setTotal(settingList.length);
    }, [settingList]);

    const columns = useMemo(() => [
        {
            id: 'NAME',
            name: UIHelper.buildTableColumn('Tên tác vụ'),
            selector: (row) => (
                <div className='p-1'>{row.name}</div>
            ),
            minWidth: '800px',
        },
        {
            name: UIHelper.buildTableColumn('Thao tác'),
            width: '140px',
            style: {
                position: 'sticky',
                right: 0,
                backgroundColor: '#fff',
                borderLeft: '1px solid #ebedfe',
            },
            cell: (row) => (
                <div>
                    {UIHelper.buildToggleSwitch(
                        !row.show,
                        async () => {
                            const newValue = Number(!row.show);
                            const res = await miscHelper.callApiUpdateConfig({
                                key: row.key,
                                value: newValue,
                            });
                            if (res) {
                                setSettingList((prev) =>
                                    prev.map((item) =>
                                        item.key === row.key ? { ...item, show: !!newValue } : item
                                    )
                                );
                                ToastHelper.showSuccess('Cài đặt thành công');
                            }
                        }
                    )}
                </div>
            ),
        },
    ], [settingList]);

    return (
        <div>
            {UIHelper.buildCard(
                <div>
                    <div className="pb-4">
                        <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Cài đặt chung
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                        {Utils.formatNumber(total)} bản ghi
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="px-4 mt-4">
                                <KTTable
                                    columns={columns}
                                    items={settingList}
                                    selectableRows={false}
                                    striped={false}
                                    compactGrid={false}
                                    onClickedRow={() => { }}
                                    onSelectedRowsChanged={() => { }}
                                    onDoubleClickedRow={() => { }}
                                    noDataComponent={UIHelper.buildEmptyNoData(
                                        'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default GeneralSettingView;
